export enum TransitDocumentFieldName {
  toCountry = 'toCountry',
  fromCountry = 'fromCountry',
  returnCountry = 'returnCountry',
  transitCountry = 'transitCountry',
  customs = 'customs',
  permitExpiredAt = 'permitExpiredAt',
  purpose = 'purpose',
}

export interface TransitDocumentFormDataProps {
  [TransitDocumentFieldName.toCountry]?: string;
  [TransitDocumentFieldName.fromCountry]?: string;
  [TransitDocumentFieldName.returnCountry]?: string;
  [TransitDocumentFieldName.transitCountry]?: string;
  [TransitDocumentFieldName.customs]?: string;

  [TransitDocumentFieldName.permitExpiredAt]?: string;
  [TransitDocumentFieldName.purpose]?: string;
}
